import React from 'react';

import gemsIconGradient from 'client/images/hidden-gems/gems-icon-gradient.svg';
import scaleIconGradient from 'client/images/hidden-gems/scale-icon-gradient.svg';
import walletIconGradient from 'client/images/hidden-gems/wallet-icon-gradient.svg';
import { EDM_LEASE_DEALS_HOW_WE_EVALUATE_CREATIVE_ID } from 'site-modules/lease-deals/constants/lease-deals-constants';

const EVALUATION_STEPS = [
  {
    stepNumber: 1,
    imageSrc: walletIconGradient,
    title: 'Calculate the true monthly cost',
    description:
      'We spread the upfront due at signing amount across the lease term, then add it to the monthly payment. This gives every lease a comparable monthly cost.',
  },
  {
    stepNumber: 2,
    imageSrc: scaleIconGradient,
    title: 'Compare cost to vehicle value',
    description:
      "We compare that true monthly cost to the car's sticker price (MSRP) to measure how much car you're getting for your money, not just how low the payment looks.",
  },
  {
    stepNumber: 3,
    imageSrc: gemsIconGradient,
    title: 'Rate lease deals based on value',
    description:
      'Only leases that deliver exceptional value earn a Gem Deal badge. Not every advertised lease offer makes the cut.',
  },
];

export function LeaseDealsEvaluation() {
  return (
    <section
      data-tracking-parent={EDM_LEASE_DEALS_HOW_WE_EVALUATE_CREATIVE_ID}
      className="mt-3 mx-auto p-1_5 p-md-2 bg-white rounded-24 text-cool-gray-10"
      aria-labelledby="lease-deals-evaluation-title"
    >
      <h2 id="lease-deals-evaluation-title" className="size-24 mt-0 mb-0 mb-md-1_5">
        How does Edmunds evaluate lease deals?
      </h2>
      <ol className="row list-unstyled g-1_5 p-0 m-0">
        {EVALUATION_STEPS.map(step => (
          <li className="col-12 col-md-4 d-flex flex-column gap-0_75" key={step.stepNumber}>
            <img
              className="d-block flex-shrink-0"
              width={70}
              height={70}
              src={step.imageSrc}
              alt=""
              aria-hidden="true"
            />
            <div>
              <p className="d-block size-16 fw-bold mb-0">Step {step.stepNumber}</p>
              <h3 className="size-20 mb-0 fw-medium">{step.title}</h3>
              <p className="mb-0">{step.description}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
